// extracted by mini-css-extract-plugin
export default {"countDownText":"CountDownRender_countDownText__Jqc2Z"};